import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IWorkflowFormState } from './workflow-form.types';
import {
  IDepartmentData,
  IWorkflowFormSubmissionChecklistData,
  IWorkflowFormSubmissionCommentData,
  IWorkflowFormSubmissionData,
  IFormTemplateData,
  IUserData
} from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IWorkflowFormState = {
  version: 1,
  workflowFormSubmissions: [] as IWorkflowFormSubmissionData[],
  workflowFormDepartments: [] as IDepartmentData[],
  workflowFormChecklists: [] as IWorkflowFormSubmissionChecklistData[],
  workflowFormSubmissionTransitions: [],
  workflowFormSubmissionAvailableAssignees: [],
  comments: [] as IWorkflowFormSubmissionCommentData[],
  checklistAssigneeOptions: [] as IUserData[],
  activities: [],
  mentionableUsers: [],
  count: 0,
  lastPromise: null
};

const namespaced = true;

export const workflowForm: Module<IWorkflowFormState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
